__turbopack_context__.v({
  "left": "Reveal-module-scss-module__xcs3jq__left",
  "reveal": "Reveal-module-scss-module__xcs3jq__reveal",
  "right": "Reveal-module-scss-module__xcs3jq__right",
  "up": "Reveal-module-scss-module__xcs3jq__up",
  "visible": "Reveal-module-scss-module__xcs3jq__visible",
});
